import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { getSettingEnableRetailerExclusivityAgreements } from "@faire/retailer-visitor-shared/settings/getSettingEnableRetailerExclusivityAgreement";
import { useQuery as useExclusivityAvailabilityQuery } from "@faire/web-api--source/endpoints/www/api/exclusivity-agreements/retailers/retailerToken/availability/get-hooks";

import { buildExclusivityQueryParams } from "./consts";

export type Options = Parameters<typeof useExclusivityAvailabilityQuery>["2"];
export const EXCLUSIVITY_AVAILABILITY_STALE_TIME = 3 * 60 * 1000;

/**
 * By default:
 * - Options.enabled = getSettingEnableRetailerExclusivityAgreements()
 * - Options.staleTime = EXCLUSIVITY_AVAILABILITY_STALE_TIME
 */
export const useExclusivityAvailability = (
  brandToken: string | undefined,
  options?: Options,
  disabled = false
) => {
  const { retailerToken = "" } = useRetailer();
  const { data: availability, ...rest } = useExclusivityAvailabilityQuery(
    retailerToken,
    buildExclusivityQueryParams(brandToken),
    {
      enabled: !disabled && getSettingEnableRetailerExclusivityAgreements(),
      staleTime: EXCLUSIVITY_AVAILABILITY_STALE_TIME,
      ...options,
    }
  );
  return { availability, ...rest };
};
